query tipoFluxoStatusSelect($where: EnumItemDTOFilterInput) {
    data: tiposFluxosStatus(where: $where)  {
        label
        value
    }
}